export default {
    serviceUrl: state => state.serviceUrl
}
